import { handleLongText } from 'config/libraries';
import React, { Fragment, useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap';
import toast, { Toaster } from 'react-hot-toast';
import { Link } from 'react-router-dom';

export const List = ({ response }) => {
    const [CurrentDataResponse, setCurrentDataResponse] = useState(null);
    const [RadioResponse, setRadioResponse] = useState([]);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    
    const [IsLoading, setIsLoading] = useState(false);

    function handleShow(data) {
        // setPayload((prevObject) => ({
        //     ...prevObject, ...{
        //         id_kategori_layanan_online: data.id,
        //     }
        // }))
        setCurrentDataResponse(data)
        setShow(true);
    }

    useEffect(() => {
        handleGetRadio()
    }, [])

    const handleGetRadio = () => {
        setIsLoading(false)
        const axios = require('axios');
        axios.get(process.env.REACT_APP_SERVER_BASE_URL + '/kategori-layanan-online').then(function (res) {
            console.log('res', res)
            setRadioResponse(res.data.data)
        }).catch(function (error) {

        }).finally(function () {
            setIsLoading(true)
        })
    };

    // if (IsLoading) {
    //     return <>Memproses ....</>
    // }

    return (
        <section className="home_section7">
            <Toaster />
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div id="blockid_84d79c5" className="block-section jl-main-block">
                            <div className="jl_grid_wrap_f jl_sf_grid jl_clear_at">
                                {
                                    window.location.pathname !== '/informasi/layanan' ?
                                        <div className="jl-roww content-inner jl-col3 jl-col-row">
                                            {
                                                response && response.map((item, index) => {

                                                    let filename = item.file_informasi.split('.').pop();
                                                    let fileData = ''
                                                    if (filename === 'jpg' || filename === 'png' || filename === 'jpeg') {
                                                        fileData = process.env.REACT_APP_SERVER_IMAGE_URL + item.file_informasi
                                                    } else {
                                                        fileData = 'https://png.pngtree.com/element_our/20190528/ourlarge/pngtree-file-icon-image_1128287.jpg'
                                                    }

                                                    return (
                                                        <div key={index} className="jl-grid-cols">
                                                            <div onClick={() => handleShow(item)} className="p-wraper post-1614 cursor-pointer">
                                                                <div className="jl_m_right jl_sm_list jl_ml jl_clear_at">
                                                                    <div className="jl_m_right_w">
                                                                        <div className="jl_m_right_img jl_radus_e">
                                                                            <img src={fileData} className="attachment-sprasa_feature_small size-sprasa_feature_small wp-post-image image-size-informasi" alt="" loading="lazy" />
                                                                        </div>
                                                                        <div className="jl_m_right_content">
                                                                            <h2 className="entry-title">{handleLongText(item.judul_informasi, 60)}</h2>
                                                                            <span className="jl_post_meta">
                                                                                <span className="jl_author_img_w"><i className="jli-user" />{item.created_at}</span>
                                                                            </span>
                                                                            <p dangerouslySetInnerHTML={{ __html: handleLongText(item.konten_informasi, 100) }}></p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }

                                        </div> :
                                        <div className="jl-roww content-inner jl-col3 jl-col-row">
                                            {
                                                RadioResponse && RadioResponse.map((item, index) => {
                                                    return (
                                                        <div key={index} className="jl-grid-cols  ">
                                                            <Link to={'/form-detail/' + item.slug_kategori + '?name=' + item.nama_kategori} className="p-wraper border  p-3 post-1614 cursor-pointer" style={{ borderRadius: 10 }}>
                                                                <div className="jl_m_right jl_sm_list jl_ml jl_clear_at">
                                                                    <div className="jl_m_right_w">
                                                                        <div className="jl_m_right_img jl_radus_e">
                                                                            {/* <img src={'https://png.pngtree.com/element_our/20190528/ourlarge/pngtree-file-icon-image_1128287.jpg'} className="attachment-sprasa_feature_small size-sprasa_feature_small wp-post-image image-size-informasi" alt="" loading="lazy" /> */}
                                                                            {
                                                                                item.icon_kategori == null || item.icon_kategori === '' ?
                                                                                <img src={'https://png.pngtree.com/element_our/20190528/ourlarge/pngtree-file-icon-image_1128287.jpg'} className="attachment-sprasa_feature_small size-sprasa_feature_small wp-post-image image-size-informasi" alt="" loading="lazy" /> :
                                                                                <img src={'http://backenddisdik.lampungtimurkab.go.id/' + item.icon_kategori} className="attachment-sprasa_feature_small size-sprasa_feature_small wp-post-image image-size-informasi" alt="" loading="lazy" />
                                                                            }
                                                                        </div>
                                                                        <div className="jl_m_right_content">
                                                                            <h2 className="entry-title">{item.nama_kategori}</h2>
                                                                            <span className="jl_post_meta">
                                                                                {/* <span className="jl_author_img_w"><i className="jli-user" />{item.created_at}</span> */}
                                                                            </span>
                                                                            <p dangerouslySetInnerHTML={{ __html: handleLongText(item.keterangan, 100) }}></p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Link>
                                                        </div>
                                                    )
                                                })
                                            }

                                        </div>
                                }

                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {
                window.location.pathname === '/informasi/bank-data' ?
                    <div>


                        <div className="row">
                            <div className="col-md-12">
                                <div id="blockid_84d79c5" className="block-section jl-main-block">
                                    <div className="jl_grid_wrap_f jl_sf_grid jl_clear_at">
                                        <div className="jl-roww content-inner jl-col3 jl-col-row">
                                            <a href='/static/sk-penetapan-website' className="jl-grid-cols">
                                                <div className="p-wraper post-1614 cursor-pointer">
                                                    <div className="jl_m_right jl_sm_list jl_ml jl_clear_at">
                                                        <div className="jl_m_right_w" style={{ width: '300px !important' }}>
                                                            <div className="jl_m_right_img jl_radus_e" style={{ width: 300 }}>
                                                                <img width={300} style={{ width: 300 }} src={'https://png.pngtree.com/element_our/20190528/ourlarge/pngtree-file-icon-image_1128287.jpg'} className="attachment-sprasa_feature_small size-sprasa_feature_small wp-post-image image-size-informasi" alt="" loading="lazy" />
                                                            </div>
                                                            <div className="jl_m_right_content">
                                                                <h2 className="entry-title">SK Penetapan Website</h2>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </a>
                                            <a href='/static/sk-tim-pengelola-website' className="jl-grid-cols">
                                                <div className="p-wraper post-1614 cursor-pointer">
                                                    <div className="jl_m_right jl_sm_list jl_ml jl_clear_at">
                                                        <div className="jl_m_right_w" style={{ width: '300px !important' }}>
                                                            <div className="jl_m_right_img jl_radus_e" style={{ width: 300 }}>
                                                                <img width={300} style={{ width: 300 }} src={'https://png.pngtree.com/element_our/20190528/ourlarge/pngtree-file-icon-image_1128287.jpg'} className="attachment-sprasa_feature_small size-sprasa_feature_small wp-post-image image-size-informasi" alt="" loading="lazy" />
                                                            </div>
                                                            <div className="jl_m_right_content">
                                                                <h2 className="entry-title">SK Tim pengelola Website</h2>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </a>
                                            <a href='/static/sk-penunjukan-petugas-meja-pelayanan-pengelola-website' className="jl-grid-cols">
                                                <div className="p-wraper post-1614 cursor-pointer">
                                                    <div className="jl_m_right jl_sm_list jl_ml jl_clear_at">
                                                        <div className="jl_m_right_w" style={{ width: '300px !important' }}>
                                                            <div className="jl_m_right_img jl_radus_e" style={{ width: 300 }}>
                                                                <img width={300} style={{ width: 300 }} src={'https://png.pngtree.com/element_our/20190528/ourlarge/pngtree-file-icon-image_1128287.jpg'} className="attachment-sprasa_feature_small size-sprasa_feature_small wp-post-image image-size-informasi" alt="" loading="lazy" />
                                                            </div>
                                                            <div className="jl_m_right_content">
                                                                <h2 className="entry-title">SK Penunjukan Petugas Meja Pelayanan</h2>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>






                    </div> : null
            }

        </section>
    )
};